let origin = window.ORIGIN;
// 话题列表
const getTopicListURL = `${origin}/gateway/hc-neighbour/topic/getTopicList`;
//登记表单
const getFormURL = `${origin}/gateway/hc-serve/miniapi/forms/formsDetails`;
//表单提交
const formsSubmitURL = `${origin}/gateway/hc-serve/miniapi/forms/formsSubmit`;

// 获取SceneParam参数
const getSceneParamUrl = `${origin}/gateway/hc-mini/qrcode/getSceneParam`;
export { getTopicListURL, getFormURL, formsSubmitURL, getSceneParamUrl };
